import { US_STATES } from '@cibo/core'
import { FilterChip, US_COUNTY_OPTIONS } from '@cibo/ui'
import { filter } from 'ramda'
import { useTranslation } from 'react-i18next'

export const FipsChip = ({
  filters: { fips, ...otherFilters },
  handleUpdate,
}: {
  filters: any & { fips?: string[] }
  handleUpdate: (newFilters: any & { fips?: string[] }) => void
}) => {
  const { t } = useTranslation('@cibo/ui/FilterChips')
  const onDelete = (fipsVal: string) => () => {
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const otherLabels = filter(label => label !== fipsVal, fips!)
    handleUpdate({ ...otherFilters, fips: otherLabels })
  }
  return (
    <>
      {fips?.map((fipsVal: string) => {
        if (fipsVal.length > 2) {
          const county = US_COUNTY_OPTIONS.find(option => option.fips === fipsVal)

          return county ? (
            <FilterChip
              key={fipsVal}
              onDelete={onDelete(fipsVal)}
              label={`${county.label}, ${county.stateLabel}`}
            />
          ) : (
            <FilterChip
              key={fipsVal}
              onDelete={onDelete(fipsVal)}
              label={t('unknownCounty', { fipsVal })}
            />
          )
        }
        const state = US_STATES.find(option => option.fips === fipsVal)
        return state ? (
          <FilterChip key={fipsVal} onDelete={onDelete(fipsVal)} label={state.label} />
        ) : (
          <FilterChip
            key={fipsVal}
            onDelete={onDelete(fipsVal)}
            label={t('unknownState', { fipsVal })}
          />
        )
      })}
    </>
  )
}
